import { Box, TableContainer } from "@material-ui/core";
import { FC } from "react";
import { useShiftPageStyles } from "../styles";
import ShiftPageTable from "./ShiftRecordTable";
import { useTableSync } from "hooks/useTableSync";
import useResize from "hooks/useResize";

const ShiftPageContainers: FC = () => {
  const classes = useShiftPageStyles();
  const { width } = useResize();
  const { t1Ref, t2Ref, t3Ref } = useTableSync();

  return (
    <Box style={{ display: "flex" }}>
      <TableContainer className={classes.tableContainer} ref={t1Ref}>
        <ShiftPageTable tableNumber={1} width={width} />
      </TableContainer>
      <TableContainer className={classes.tableContainer2} ref={t2Ref}>
        <ShiftPageTable tableNumber={2} width={width} />
      </TableContainer>
      <TableContainer className={classes.tableContainer3} ref={t3Ref}>
        <ShiftPageTable tableNumber={3} width={width} />
      </TableContainer>
    </Box>
  );
};

export default ShiftPageContainers;
